/* eslint max-lines: off */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import selectors from 'state/selectors';
import service from 'services';
import utils from 'utils';
import actions from 'state/actions';

import TextArea from 'components/Input/Textarea';
import Modal from 'components/Modal';
import styled from 'styled-components/macro';
import { modalActionType } from 'utils/constants';

const Section = styled.div`
  margin: 30px 0;
`;

export const Title = styled.h4`
  margin-bottom: 10px;
`;

const MultipleConvalida = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();
  const documentsID = useSelector(selectors.documents.selectAllActiveDocumentsID);

  const [note, setNote] = useState<string>('');

  const onNoteChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNote(e.target.value);
  };

  const handleConfirm = async () => {
    try {
      const { data } = await service.approveWfTask({
        protocols: documentsID,
        note: note,
      });
      dispatch(actions.modal.closeModal());

      const protocolsApproved = data.filter((el) => el.responseStatus === 'OK').map((el) => el.protocol);
      dispatch(actions.documents.removeRows(protocolsApproved));

      const protocolsNotApproved = data.filter((el) => el.responseStatus === 'KO');

      if (!protocolsNotApproved.length) {
        utils.app.notify('success', t('success_convalidate'));
        return;
      }

      setTimeout(() => {
        dispatch(
          actions.modal.openModal(modalActionType.documents.MULTIPLE_CONFIRM_ERRORS, {
            list: protocolsNotApproved,
          }),
        );
      }, 400);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Modal.Header title={t('multiple-confirm-title')} subtitle={t('multilple-confirm-desc')} />
      <Modal.Content>
        <Section>
          <Title>{t('note')}</Title>
          <TextArea name="Nota" placeholder={t('note here')} onChange={onNoteChange} />
        </Section>
      </Modal.Content>
      <Modal.Footer confirmText={t('continue')} confirmAction={handleConfirm} confirmDisabled={false} />
    </>
  );
};

export default MultipleConvalida;
